enum baseUrlPathImage  {
           //test = "https://localhost:44383",
          test = "https://www.quizapp.somee.com",
    }
    export default baseUrlPathImage